import { render, staticRenderFns } from "./Heading1.vue?vue&type=template&id=24f6d119&"
import script from "./Heading1.vue?vue&type=script&lang=js&"
export * from "./Heading1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports